/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Androidbeta_Meta_Title1Inputs */

const id_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta Android - egdata.app`)
};

const ms_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta Android - egdata.app`)
};

const da_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android Beta - egdata.app`)
};

const de_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android Beta - egdata.app`)
};

const en_us2_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android Beta - egdata.app`)
};

const es_es2_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta de Android - egdata.app`)
};

const es_mx2_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta de Android - egdata.app`)
};

const fil_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android Beta - egdata.app`)
};

const fr_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta Android - egdata.app`)
};

const it_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta Android - egdata.app`)
};

const hu_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android Beta - egdata.app`)
};

const nl_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android Bèta - egdata.app`)
};

const no_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android Beta - egdata.app`)
};

const pl_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta Android - egdata.app`)
};

const pt_br2_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android Beta - egdata.app`)
};

const pt_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta Android - egdata.app`)
};

const ro_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta Android - egdata.app`)
};

const fi_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android Beta - egdata.app`)
};

const sv_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android Beta - egdata.app`)
};

const vi_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beta Android - egdata.app`)
};

const tr_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android Beta - egdata.app`)
};

const cs_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android Beta - egdata.app`)
};

const bg_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android Beta - egdata.app`)
};

const ru_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android Бета — egdata.app`)
};

const uk_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android Beta - egdata.app`)
};

const ar_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إصدار Android التجريبي - egdata.app`)
};

const hi_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android बीटा - egdata.app`)
};

const th_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android เบต้า - egdata.app`)
};

const ja_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android ベータ - egdata.app`)
};

const zh_cn2_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android内测版 - egdata.app`)
};

const zh_hant1_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android內測版 - egdata.app`)
};

const ko_misc_androidbeta_meta_title1 = /** @type {(inputs: Misc_Androidbeta_Meta_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Android 베타 - egdata.app`)
};

/**
* | output |
* | --- |
* | "Android Beta - egdata.app" |
*
* @param {Misc_Androidbeta_Meta_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_androidbeta_meta_title1 = /** @type {((inputs?: Misc_Androidbeta_Meta_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Androidbeta_Meta_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_androidbeta_meta_title1(inputs)
	if (locale === "ms") return ms_misc_androidbeta_meta_title1(inputs)
	if (locale === "da") return da_misc_androidbeta_meta_title1(inputs)
	if (locale === "de") return de_misc_androidbeta_meta_title1(inputs)
	if (locale === "en-US") return en_us2_misc_androidbeta_meta_title1(inputs)
	if (locale === "es-ES") return es_es2_misc_androidbeta_meta_title1(inputs)
	if (locale === "es-MX") return es_mx2_misc_androidbeta_meta_title1(inputs)
	if (locale === "fil") return fil_misc_androidbeta_meta_title1(inputs)
	if (locale === "fr") return fr_misc_androidbeta_meta_title1(inputs)
	if (locale === "it") return it_misc_androidbeta_meta_title1(inputs)
	if (locale === "hu") return hu_misc_androidbeta_meta_title1(inputs)
	if (locale === "nl") return nl_misc_androidbeta_meta_title1(inputs)
	if (locale === "no") return no_misc_androidbeta_meta_title1(inputs)
	if (locale === "pl") return pl_misc_androidbeta_meta_title1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_androidbeta_meta_title1(inputs)
	if (locale === "pt") return pt_misc_androidbeta_meta_title1(inputs)
	if (locale === "ro") return ro_misc_androidbeta_meta_title1(inputs)
	if (locale === "fi") return fi_misc_androidbeta_meta_title1(inputs)
	if (locale === "sv") return sv_misc_androidbeta_meta_title1(inputs)
	if (locale === "vi") return vi_misc_androidbeta_meta_title1(inputs)
	if (locale === "tr") return tr_misc_androidbeta_meta_title1(inputs)
	if (locale === "cs") return cs_misc_androidbeta_meta_title1(inputs)
	if (locale === "bg") return bg_misc_androidbeta_meta_title1(inputs)
	if (locale === "ru") return ru_misc_androidbeta_meta_title1(inputs)
	if (locale === "uk") return uk_misc_androidbeta_meta_title1(inputs)
	if (locale === "ar") return ar_misc_androidbeta_meta_title1(inputs)
	if (locale === "hi") return hi_misc_androidbeta_meta_title1(inputs)
	if (locale === "th") return th_misc_androidbeta_meta_title1(inputs)
	if (locale === "ja") return ja_misc_androidbeta_meta_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_androidbeta_meta_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_androidbeta_meta_title1(inputs)
	return ko_misc_androidbeta_meta_title1(inputs)
});
export { misc_androidbeta_meta_title1 as "misc.androidBeta.meta.title" }